import { saveXLSX } from "@util/save-xlsx";

/**
 * Parse an HTML table (agent markdown) into row objects and download as .xlsx.
 */
export function exportHtmlTableToXlsx(
  table: HTMLTableElement,
  fileName: string = "agent-table.xlsx"
): boolean {
  if (!table) {
    return false;
  }
  const headers = Array.from(table.querySelectorAll("thead th")).map((th) =>
    (th.textContent || "").trim()
  );
  const bodyRows = Array.from(table.querySelectorAll("tbody tr"));
  if (!headers.length || !bodyRows.length) {
    return false;
  }
  const rows: Record<string, string>[] = bodyRows.map((tr) => {
    const cells = Array.from(tr.querySelectorAll("td")).map((td) =>
      (td.textContent || "").trim()
    );
    const row: Record<string, string> = {};
    headers.forEach((h, i) => {
      const key = h || `col_${i + 1}`;
      row[key] = cells[i] != null ? cells[i] : "";
    });
    return row;
  });
  saveXLSX(rows, fileName.endsWith(".xlsx") ? fileName : `${fileName}.xlsx`);
  return true;
}

/** True if click target is the agent markdown Excel export control. */
export function isAiMdTableExportClick(event: Event): HTMLTableElement | null {
  const target = event.target as HTMLElement | null;
  if (!target) {
    return null;
  }
  const btn = target.closest(".ai-md-table-export") as HTMLElement | null;
  if (!btn) {
    return null;
  }
  event.preventDefault();
  event.stopPropagation();
  const wrap = btn.closest(".ai-md-table-wrap");
  return (wrap?.querySelector("table.ai-md-table") as HTMLTableElement) || null;
}
